import { render, staticRenderFns } from "./IngredientsList.vue?vue&type=template&id=961cd29a&"
import script from "./IngredientsList.vue?vue&type=script&lang=js&"
export * from "./IngredientsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports